import React, { Suspense, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { getTxnTextBasedOnType } from 'shared/utils';
import { companyInfoSelectors } from 'store/companyInfo/selectors';
import { saleSelectors } from 'store/sale/selectors';
import { CompanyInfo } from 'types/CompanyInfo';
import { InvoiceDocument } from 'types/InvoiceDocument';
import { Sale } from 'types/Sale';

// Lazy components for accepted success screen functionality
const LazyAcceptedSuccessScreen = React.lazy(
  () => import('components/Core/SuccessScreen/Estimate/Accepted/AcceptedSuccessScreen')
);

const SpinnerCentered = () => (
  <React.Fragment>
    <style jsx>{`
      .spinner-wrapper {
        width: 100px;
        margin: 50px auto;
      }
    `}</style>
    <div className="spinner-wrapper">
      <div>Loading...</div>
    </div>
  </React.Fragment>
);

interface UseAcceptedSuccessScreenProps {
  isChangeOrder: boolean;
  sale: Sale;
  companyInfo: CompanyInfo;
  invoiceDocument: InvoiceDocument;
  viewPDF: () => void;
  handleDownloadPDF: () => void;
}

export const useAcceptedSuccessScreen = ({
  isChangeOrder,
  sale,
  companyInfo,
  invoiceDocument,
  viewPDF,
  handleDownloadPDF,
}: UseAcceptedSuccessScreenProps) => {
  const pdfStatus = {
    url: invoiceDocument.PDFDocumentBlobUrl || null,
  };

  return (
    <Fragment>
      <Suspense fallback={<SpinnerCentered />}>
        <LazyAcceptedSuccessScreen
          subTitle={
            <FormattedMessage
              id="ACCEPTED_SUCCESS_SCREEN_ACCEPT_MESSAGE"
              defaultMessage="You accepted this {transaction}"
              values={{
                transaction: getTxnTextBasedOnType(isChangeOrder).transaction_text,
              }}
            />
          }
          companyName={companyInfoSelectors.nameSelector(companyInfo) || ''}
          acceptedDate={new Date()}
          total={saleSelectors.amountSelector(sale) || 0}
          currency={saleSelectors.currencySelector(sale) || 'USD'}
          companyLocale={companyInfoSelectors.localeSelector(companyInfo) || ''}
          viewEstimateHandler={viewPDF}
          downloadPDF={handleDownloadPDF}
          isChangeOrder={isChangeOrder}
        />
      </Suspense>
      {pdfStatus.url && (
        <iframe id="hiddenPDFIframe" src={pdfStatus.url} style={{ display: 'none' }} />
      )}
    </Fragment>
  );
};
